// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iZ-I","largestCol":"styles_largestCol__MPsaj","smallestCol":"styles_smallestCol__85iaZ"};